// extracted by mini-css-extract-plugin
export default {"owner":"jVIHfI60GEEIbZ0y9ZAO"};